import { gql } from "@apollo/client";

// ─── Storage (Image Upload) ─────────────────────────────────────────────────
// Shared presigned-URL upload flow used across features (marketplace, org settings, etc.)

export const REQUEST_UPLOAD_URL = gql`
  mutation RequestUploadUrl(
    $purpose: UploadPurpose!
    $entityId: String!
    $contentType: String!
  ) {
    requestUploadUrl(
      purpose: $purpose
      entityId: $entityId
      contentType: $contentType
    ) {
      uploadUrl
      cdnUrl
      key
      expiresIn
    }
  }
`;

export const CONFIRM_UPLOAD = gql`
  mutation ConfirmUpload($key: String!) {
    confirmUpload(key: $key) {
      cdnUrl
      contentLength
      contentType
    }
  }
`;
